import { observer } from 'mobx-react';
import * as React from 'react';
import { DragHandleProps } from '../../../../../../../../Draggable/Types';
import { ExperienceResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import ExperienceRowItems from './ExperienceRowItems';
import ExperienceRowItemsWithHandlers from './ExperienceRowItemsWithHandlers';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  store: LearningCollectionEditStore;
  dragHandleProps: DragHandleProps;
}

const CustomizeRow: React.FC<Props> = ({ context, dragHandleProps, experienceResource, store }) => {
  switch (context.kind) {
    case 'section-context':
      switch (context.section.resource.payload.learningDesignState) {
        case 'curated':
          return <ExperienceRowItems experienceResource={experienceResource} />;
        case 'curated-custom':
        case 'custom':
        case 'blank':
        case 'build-your-own':
        case 'browse-all':
          return (
            <ExperienceRowItemsWithHandlers
              context={context}
              store={store}
              experienceResource={experienceResource}
              dragHandleProps={dragHandleProps}
            />
          );
        case 'empty':
          return <></>;
      }
    case 'browse-all-experiences':
      return (
        <ExperienceRowItemsWithHandlers
          context={context}
          store={store}
          experienceResource={experienceResource}
          dragHandleProps={dragHandleProps}
        />
      );
  }
};

export default observer(CustomizeRow);
